import React, { PureComponent } from 'react';

export default class OPPureComponent extends PureComponent {
  constructor(props) {
    super(props);
  }
}
